import { render, staticRenderFns } from "./linkDe.vue?vue&type=template&id=09ad112a&scoped=true&"
import script from "./linkDe.vue?vue&type=script&lang=js&"
export * from "./linkDe.vue?vue&type=script&lang=js&"
import style0 from "./linkDe.vue?vue&type=style&index=0&id=09ad112a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ad112a",
  null
  
)

export default component.exports